
import React, { useState, useEffect } from 'react'
import { ClimbingBoxLoader } from 'react-spinners'
import { AnimatePresence, motion } from 'framer-motion'
import { Box } from '@mui/material'

function SuspenseLoading() {
  const [show, setShow] = useState(false)
  useEffect(() => {
    let timeout = setTimeout(() => setShow(true), 300)
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <>
      <AnimatePresence>
        {show && (
          <motion.div
            key="loading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                height: '100vh',
                justifyContent: 'center',
                textAlign: 'center',
                py: '1rem',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  px: '1.5rem',
                }}
              >
                <ClimbingBoxLoader color={'#3c44b1'} loading={true} />
              </Box>
              <Box sx={[{ color: '#a6a6b9', textAlign: 'center', pt: '1rem', }, { fontSize: "1.265rem !important" }]}>
                Please wait while we load the live preview examples
                <Box component="span" sx={[{ display: 'block', color: '#4f5062' }, { fontSize: "1.15rem !important" }]}>
                  This live preview instance can be slower than a real
                  production build!
                </Box>
              </Box>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default SuspenseLoading
